<div class="modal-montage-viewer">
  <h3 class="vision-h3">{{ extension?.file?.name }}</h3>
  <div class="modal-body">
    <div id="montage-viewer">
      <div class="montage-d3-map"></div>
      <div class="montage-d3-buttons">
        <fw-button variant="outline" class="montage-d3-reset montage-d3-viewer-button" (click)="reset()">
          Reset
        </fw-button>
        <fw-button variant="outline" class="montage-d3-zoom montage-d3-viewer-button" (click)="zoomButtonClicked(1)">
          Zoom In
        </fw-button>
        <fw-button variant="outline" class="montage-d3-zoom montage-d3-viewer-button" (click)="zoomButtonClicked(-1)">
          Zoom Out
        </fw-button>
      </div>
    </div>
  </div>
</div>